module.exports = __webpack_public_path__ + "img/news-title-ja.869d4289.png";